/* pdp-variations.js — interactions for the Dansu PDP variation templates.
   Wired to REAL product data injected via data-* attributes by the Liquid section,
   and to the theme's native Shopify AJAX cart (cart-drawer / cart-notification).

   The PRIMARY product Add-to-cart is a native <product-form> + {% form 'product' %},
   so the theme's product-form.js handles that submit with zero extra code here.
   This file handles: gallery dots/thumbs, V2 2nd-design toggle + live price,
   V3 towel-rail switch (navigates to the design's PDP), V3 tiered pack builder
   (adds N of the current variant via /cart/add.js), V3 mobile sticky bar, toast. */
(function () {
  var CHECK = '<svg width="13" height="10" viewBox="0 0 12 9" fill="none"><path fill="currentColor" fill-rule="evenodd" d="M11.35.643a.5.5 0 0 1 .006.707l-6.77 6.886a.5.5 0 0 1-.719-.006L.638 4.845a.5.5 0 1 1 .724-.69l2.872 3.011 6.41-6.517a.5.5 0 0 1 .707-.006z" clip-rule="evenodd"/></svg>';

  function money(cents) {
    // Use theme money format if available, else GBP fallback.
    var fmt = (window.Shopify && window.Shopify.money_format) || '£{{amount}}';
    var amount = (cents / 100).toFixed(2);
    return fmt.replace(/\{\{\s*amount\s*\}\}/, amount).replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents / 100));
  }

  function toast(msg) {
    var t = document.createElement('div');
    t.className = 'pdp-var-toast';
    t.innerHTML = '<span class="ck">' + CHECK + '</span>' + msg;
    document.body.appendChild(t);
    setTimeout(function () {
      t.style.transition = 'opacity .3s';
      t.style.opacity = '0';
      setTimeout(function () { t.remove(); }, 300);
    }, 1700);
  }

  function getCart() {
    return document.querySelector('cart-notification') || document.querySelector('cart-drawer');
  }

  // Add an arbitrary quantity of a variant via AJAX, then refresh the theme cart UI.
  function addVariant(variantId, quantity, onDone) {
    var cart = getCart();
    var body = { items: [{ id: Number(variantId), quantity: Number(quantity) || 1 }] };
    var sectionsBody = {};
    var fd = body;
    if (cart && typeof cart.getSectionsToRender === 'function') {
      var sections = cart.getSectionsToRender().map(function (s) { return s.id; });
      fd = { items: body.items, sections: sections, sections_url: window.location.pathname };
    }
    fetch((window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(fd),
      credentials: 'same-origin'
    })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res && res.status) { // error shape from Shopify
          toast(res.description || res.message || 'Could not add to bag');
          if (onDone) onDone(false);
          return;
        }
        if (cart && typeof cart.renderContents === 'function') {
          if (cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
          cart.renderContents(res);
        } else {
          toast('Added to bag');
        }
        if (onDone) onDone(true);
      })
      .catch(function () { toast('Network error — please try again'); if (onDone) onDone(false); });
  }

  document.querySelectorAll('[data-pdp-var]').forEach(function (root) {
    var variantId = root.getAttribute('data-variant-id');
    var unitCents = parseInt(root.getAttribute('data-unit-cents'), 10) || 0;

    /* ---- gallery: dots + thumbs <-> scroll track ---- */
    var track = root.querySelector('[data-g-track]');
    var dots = root.querySelectorAll('[data-dots] i');
    var thumbs = root.querySelectorAll('[data-thumb]');
    function activate(idx) {
      dots.forEach(function (d, i) { d.classList.toggle('on', i === idx); });
      thumbs.forEach(function (t, i) { t.classList.toggle('on', i === idx); });
    }
    function goTo(idx) {
      if (track) {
        var slide = track.children[idx];
        if (slide) track.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' });
      }
      activate(idx);
    }
    dots.forEach(function (d, i) { d.addEventListener('click', function () { goTo(i); }); });
    thumbs.forEach(function (t, i) { t.addEventListener('click', function () { goTo(i); }); });
    if (track) {
      var raf;
      track.addEventListener('scroll', function () {
        if (raf) cancelAnimationFrame(raf);
        raf = requestAnimationFrame(function () {
          var idx = Math.round(track.scrollLeft / track.clientWidth);
          activate(idx);
        });
      });
    }

    /* ---- V2: "Add a 2nd design" toggle (live price + label + reveal picker) ---- */
    var toggle = root.querySelector('[data-toggle]');
    if (toggle) {
      toggle.addEventListener('click', function (e) {
        // don't toggle when clicking inside the revealed design picker
        if (e.target.closest('[data-design2]')) return;
        toggle.classList.toggle('on');
        var on = toggle.classList.contains('on');
        var pp = toggle.querySelector('.pp');
        var label = root.querySelector('[data-clabel]');
        var second = getSelectedSecondDesign();
        var secondCents = second ? parseInt(second.getAttribute('data-cents'), 10) : unitCents;
        if (on) {
          if (pp) pp.textContent = 'Added';
          if (label) label.textContent = 'Add 2 to cart · ' + money(unitCents + secondCents);
        } else {
          if (pp) pp.textContent = '+' + money(secondCents);
          if (label) label.textContent = 'Add to cart · ' + money(unitCents);
        }
      });
    }
    function getSelectedSecondDesign() {
      return root.querySelector('[data-design2] [data-second].on') || root.querySelector('[data-design2] [data-second]');
    }
    root.querySelectorAll('[data-design2] [data-second]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        root.querySelectorAll('[data-design2] [data-second]').forEach(function (b) { b.classList.remove('on'); });
        btn.classList.add('on');
        // if toggle already on, refresh the live label with the new pick
        if (toggle && toggle.classList.contains('on')) {
          var label = root.querySelector('[data-clabel]');
          var secondCents = parseInt(btn.getAttribute('data-cents'), 10) || unitCents;
          if (label) label.textContent = 'Add 2 to cart · ' + money(unitCents + secondCents);
        }
      });
    });

    /* ---- V2: intercept the rave button to do a real 2-line add when toggle on ---- */
    var v2Form = root.querySelector('[data-v2-form]');
    if (v2Form) {
      var v2FormEl = v2Form.closest('form');
      if (v2FormEl) v2FormEl.addEventListener('submit', function (e) {
        if (!toggle || !toggle.classList.contains('on')) return; // let native single add proceed
        e.preventDefault();
        e.stopImmediatePropagation(); // block the theme's product-form single-add for this submit
        var second = getSelectedSecondDesign();
        if (!second) { toast('Pick a 2nd design first'); return; }
        var secondVariant = second.getAttribute('data-variant-id');
        var cart = getCart();
        var items = [{ id: Number(variantId), quantity: 1 }, { id: Number(secondVariant), quantity: 1 }];
        var payload = { items: items };
        if (cart && typeof cart.getSectionsToRender === 'function') {
          payload.sections = cart.getSectionsToRender().map(function (s) { return s.id; });
          payload.sections_url = window.location.pathname;
        }
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify(payload), credentials: 'same-origin'
        }).then(function (r) { return r.json(); }).then(function (res) {
          if (res && res.status) { toast(res.description || 'Could not add bundle'); return; }
          if (cart && typeof cart.renderContents === 'function') {
            if (cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
            cart.renderContents(res);
          } else { toast('Bundle added to bag'); }
        }).catch(function () { toast('Network error'); });
      }, true); // capture: run before the theme's product-form submit handler
    }

    /* ---- V3: towel rail — navigate to the chosen design's PDP (keeps the view) ---- */
    // Rail items are <a href=...> so they work without JS; nothing extra needed here.

    /* ---- V3: tiered pack builder (Single/Duo/Crew) ---- */
    var packs = root.querySelector('[data-packs]');
    var packState = { q: 1, cents: unitCents };
    if (packs) {
      // Support both legacy .pk/.on classes (V3 template) and new .rp-pk/.rp-pk--on classes (default PDP widget)
      var pkClass = packs.querySelector('.rp-pk') ? 'rp-pk' : 'pk';
      var pkOnClass = pkClass === 'rp-pk' ? 'rp-pk--on' : 'on';
      packs.querySelectorAll('.' + pkClass).forEach(function (pk) {
        pk.addEventListener('click', function () {
          packs.querySelectorAll('.' + pkClass).forEach(function (b) { b.classList.remove(pkOnClass); });
          pk.classList.add(pkOnClass);
          var q = parseInt(pk.getAttribute('data-q'), 10) || 1;
          var packCents = parseInt(pk.getAttribute('data-cents'), 10) || (unitCents * q);
          packState.q = q; packState.cents = packCents;
          packState.discountCode = pk.getAttribute('data-discount-code') || null;
          var fullCents = unitCents * q;
          var saveCents = fullCents - packCents;
          // sticky-bar price
          var bprice = root.querySelector('[data-bprice]');
          if (bprice) bprice.textContent = money(packCents);
          // CTA labels — builder mode: no price, simple ADD TO CART / ADD TO RAVEPACK
          var _packMode = root.getAttribute('data-pack-mode');
          var label = root.querySelector('[data-clabel]');
          var L_CART = root.getAttribute('data-label-cart') || 'Add to cart';
          var L_RAVE = root.getAttribute('data-label-ravepack') || 'Add to Rave Pack';
          if (label) {
            if (_packMode === 'builder' && q > 1) {
              label.textContent = L_RAVE;
            } else if (_packMode === 'builder') {
              label.textContent = L_CART;
            } else {
              label.textContent = 'Add' + (q > 1 ? ' ' + q : '') + ' to cart · ' + money(packCents);
            }
          }
          var mlabel = root.querySelector('[data-mclabel]');
          if (mlabel) mlabel.textContent = 'Add' + (q > 1 ? ' ' + q : '') + ' · ' + money(packCents);
          // Sync sticky-bar CTA label with the same rule
          var stickyLabel = document.querySelector('[data-sticky-cta-label]');
          if (stickyLabel && _packMode === 'builder') {
            stickyLabel.textContent = q > 1 ? L_RAVE : L_CART;
          }
          // save note
          var save = root.querySelector('[data-save]');
          if (save) {
            if (saveCents > 1) { save.style.display = 'block'; save.textContent = "You're saving " + money(saveCents) + ' with this pack'; }
            else { save.style.display = 'none'; }
          }
        });
      });
    }

    /* ---- V3 / default-PDP: pack add buttons ----
       Two modes, keyed by data-pack-mode on the root element:
       - (no attribute / absent)  → V3 behaviour: always AJAX-add packState.q to cart.
       - "builder"                → default-PDP behaviour: SINGLE (q=1) triggers the
         hidden product-form submit for a native add-to-cart; DUO/CREW redirect to
         /pages/build-your-rave-pack?add=<handle>. V3 is unaffected (it has no
         data-pack-mode attribute). */
    var packMode = root.getAttribute('data-pack-mode');
    var productHandle = root.getAttribute('data-product-handle');
    root.querySelectorAll('[data-pack-add]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        // Accessory mode: SINGLE native-add; DUO/CREW add qty N then /checkout?discount=BUNDLE##
        if (packMode === 'accessory') {
          if (packState.q === 1) {
            var formIdA = btn.getAttribute('data-pack-form-id');
            var hiddenA = formIdA ? document.querySelector('#' + formIdA + ' [name="add"]') : null;
            if (hiddenA) { hiddenA.click(); }
            else { var anyA = document.querySelector('product-form form [name="add"]'); if (anyA) anyA.click(); }
            return;
          }
          btn.setAttribute('aria-disabled', 'true');
          addVariant(variantId, packState.q, function (ok) {
            btn.removeAttribute('aria-disabled');
            if (ok) {
              var code = packState.discountCode;
              window.location = code
                ? '/checkout?discount=' + encodeURIComponent(code)
                : '/checkout';
            }
          });
          return;
        }
        if (packMode === 'builder' && packState.q > 1 && productHandle) {
          // DUO or CREW on the default PDP → hand off to the bundle builder
          window.location = '/pages/build-your-rave-pack?add=' + encodeURIComponent(productHandle);
          return;
        }
        if (packMode === 'builder' && packState.q === 1) {
          // SINGLE on the default PDP → trigger the hidden native product-form submit
          var formId = btn.getAttribute('data-pack-form-id');
          var hiddenSubmit = formId
            ? document.querySelector('#' + formId + ' [name="add"]')
            : null;
          if (hiddenSubmit) {
            hiddenSubmit.click();
          } else {
            // Fallback: find any submit[name="add"] inside a product-form on the page
            var anySubmit = document.querySelector('product-form form [name="add"]');
            if (anySubmit) anySubmit.click();
          }
          return;
        }
        // V3 default: AJAX add
        btn.setAttribute('aria-disabled', 'true');
        addVariant(variantId, packState.q, function () { btn.removeAttribute('aria-disabled'); });
      });
    });

    // Sticky-bar single CTA: mirror the main button — multi (q>1) hands off to the
    // builder (towels) or checkout-with-code (accessory); single lets the native
    // product-form submit (add to cart).
    var stickyPackCta = document.querySelector('[data-sticky-pack-cta]');
    if (stickyPackCta) {
      stickyPackCta.addEventListener('click', function (e) {
        if (packMode === 'accessory' && packState.q > 1) {
          e.preventDefault();
          addVariant(variantId, packState.q, function (ok) {
            if (ok) {
              var code = packState.discountCode;
              window.location = code ? '/checkout?discount=' + encodeURIComponent(code) : '/checkout';
            }
          });
          return;
        }
        if (packMode === 'builder' && packState.q > 1 && productHandle) {
          e.preventDefault();
          window.location = '/pages/build-your-rave-pack?add=' + encodeURIComponent(productHandle);
        }
      });
    }
  });
})();
